import { AtsExtraFieldTypeEnum } from '@/generated/graphql/types';

// Returns the appropriate currency symbol based on field type and currency code
// Used for displaying currency values in extra fields
export const getCurrencySymbol = (
  fieldType: AtsExtraFieldTypeEnum,
  currency?: string | null,
): string => {
  if (fieldType === AtsExtraFieldTypeEnum.CurrencyField) {
    return currency === 'EUR' ? '€' : '$';
  }
  return '';
};
